export const EMAIL_SUPORT = 'iancu2cristina19@stud.ase.ro';

// singura specializare disponibila la forma de invatamant ID
export const SPECIALIZARE_ID = 'Informatică Economică';

// specializare cu alta metoda de inscriere la licenta
export const SPECIALIZARE_SPE = 'Statistică și Previziune Economică';

// data pana la care platforma e disponibila, din REACT_APP_DATA_LIMITA (AAAA-LL-ZZ)
export const dataLimita = (valoare = process.env.REACT_APP_DATA_LIMITA) => {
  if (!valoare) return 'începutul lunii noiembrie';
  const data = new Date(`${valoare}T00:00:00`);
  if (Number.isNaN(data.getTime())) return valoare;
  return data.toLocaleDateString('ro-RO', { day: 'numeric', month: 'long', year: 'numeric' });
};

// gradul didactic e salvat in baza de date fara diacritice (valoare ENUM);
// pentru afisare se foloseste varianta cu diacritice
const ETICHETE_GRAD = { 'Conferentiar universitar': 'Conferențiar universitar' };
export const etichetaGrad = (valoare) => ETICHETE_GRAD[valoare] || valoare || '';
export const valoareGrad = (eticheta) =>
  Object.keys(ETICHETE_GRAD).find((k) => ETICHETE_GRAD[k] === eticheta) || eticheta;
